export const cleanString = (text: string): string => {
  if (!text) return '';

  return text
    .normalize('NFD')
    .replaceAll(' ', '_')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
};

export function capitalize(value: string) {
  const arr = value.split(' ');

  for (let i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1).toLowerCase();
  }

  return arr.join(' ');
}

export function textDeleteSpace(text) {
  const regex = /\s+/g;
  return text.replace(regex, '');
}

export function textTrimEdges(text: string) {
  const regex = /^[^a-zA-Z0-9]+|[^a-zA-Z0-9]+$/g;
  return text.replace(regex, '');
}

export function removeTildes (text: string | null | undefined) {
  if (text === null || text === undefined) return '';
  return text.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

export function cleanSpacesString(text: string) {
  return text.replace(/\s+/g, '');
}

export function stringToRegex(str: string): RegExp {
  const regexPattern = str.replace(/^\/|\/$/g, ''); // Remove leading and trailing slashes
  return new RegExp(regexPattern);
}

export function padWithZero(
  number: string | number,
  padLength: number
): string {
  return number.toString().padStart(padLength, '0');
}

export function truncateStart(str: string, maxLength = 4) {
  if (str.length > maxLength) {
    return '...' + str.slice(-maxLength);
  } else {
    return str;
  }
}

export function isNullString(value: string | null | undefined): boolean {
  return value === 'null' || value === null || value === undefined;
}
